import { SideNavCategory } from '../../../components/side-nav';
import { StandardReport } from '../../../models';
import { buildReportCategories } from './buildReportCategories';
import { fetchStandardReports } from '../../../api';
import { CACHE_CONFIG } from '../../../constants';
import { withCache } from '../../../util';
import { buildAllReportCategory } from './buildAllReportCategory';

export const fetchStandardReportCategoriesWithCache = async (
  clientId: number,
): Promise<SideNavCategory<StandardReport>> => {
  return withCache(
    async (): Promise<SideNavCategory<StandardReport>> => {
      const standardReports: Array<StandardReport> = await fetchStandardReports(
        clientId,
      );
      const newCategories = buildReportCategories(standardReports);

      const allReportCategory = buildAllReportCategory(newCategories);
      newCategories.items.unshift(allReportCategory);

      return newCategories;
    },
    {
      ...CACHE_CONFIG.STANDARD_REPORT_CATEGORY,
      key: `${CACHE_CONFIG.STANDARD_REPORT_CATEGORY.key}-${clientId}`,
    },
  );
};
